import { Injectable } from '@angular/core';
import { find } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { DsoService } from './dso.service';

@Injectable({
  providedIn: 'root',
})
export class DsoStoreService {
  private readonly dsoStore: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private readonly selectedDsoStore: BehaviorSubject<any> = new BehaviorSubject(null);

  public readonly dso$ = this.dsoStore.pipe(
    map((x) => {
      x.forEach((d) => delete d['users']);
      return x;
    }),
  );

  public readonly selectedDso$ = this.selectedDsoStore.asObservable();
  public readonly substation$ = this.dsoStore.asObservable();

  constructor(private dsoService: DsoService) {
    this.dsoService.get().subscribe((x) => this.dsoStore.next(x));
  }

  public get dsos() {
    return this.dsoStore.getValue();
  }

  public get substations() {
    return this.dsoStore.getValue();
  }

  public setSelectedDso = (dso: any) => this.selectedDsoStore.next(dso);

  public findDsoByGuid = (guid: string) => this.dsoStore.pipe(map((dsos) => find(dsos, (dso) => dso.guid === guid)));

  public updateDso = (dso: any) => this.dsoStore.next(dso);
}
